import { getCsrfToken } from './csrf.js';

export class ApiError extends Error {
  constructor(status, message) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

const MUTATING_METHODS = ['POST', 'PUT', 'DELETE', 'PATCH'];

export const UNAUTHORIZED_EVENT = 'boda:unauthorized';

export async function apiFetch(url, opts = {}) {
  const method = (opts.method || 'GET').toUpperCase();
  const headers = { 'Content-Type': 'application/json', ...(opts.headers || {}) };

  if (MUTATING_METHODS.includes(method)) {
    const csrf = getCsrfToken();
    if (csrf) headers['X-CSRF-Token'] = csrf;
  }

  const fetchOpts = {
    ...opts,
    method,
    headers,
    credentials: 'include',
  };

  if (opts.body !== undefined) {
    fetchOpts.body = typeof opts.body === 'string' ? opts.body : JSON.stringify(opts.body);
  }

  const res = await fetch(url, fetchOpts);

  if (res.status === 401) {
    if (!opts.silent && typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(UNAUTHORIZED_EVENT));
    }
    throw new ApiError(401, 'No autorizado');
  }

  if (res.status === 423) {
    const body = await safeJson(res);
    throw new ApiError(423, body.message || 'Recurso bloqueado');
  }

  if (!res.ok) {
    const body = await safeJson(res);
    throw new ApiError(res.status, body.message || res.statusText || 'Error en la solicitud');
  }

  if (res.status === 204) return null;

  return res.json();
}

async function safeJson(res) {
  try {
    return await res.json();
  } catch {
    return {};
  }
}
